export const imageWrapperStyles = {
  width: { xs: 24, md: 44 },
  height: { xs: 24, md: 44 },
  mb: { xs: 1, md: 4 },
  mx: "auto",
}